"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onRouteUpdate = void 0;

var onRouteUpdate = function onRouteUpdate(_ref, _ref2) {
  var location = _ref.location;
  var accountId = _ref2.accountId;
  if (process.env.NODE_ENV !== 'production') return;
  window._qevents = window._qevents || []; // wrap inside a timeout to make sure react-helmet is done with it's changes (https://github.com/gatsbyjs/gatsby/issues/9139)
  // reactHelmet is using requestAnimationFrame so we should use it too: https://github.com/nfl/react-helmet/blob/5.2.0/src/HelmetUtils.js#L296-L299

  var sendPageView = function sendPageView() {
    window._qevents.push({
      qacct: accountId
    });
  };

  if ("requestAnimationFrame" in window) {
    requestAnimationFrame(function () {
      requestAnimationFrame(sendPageView);
    });
  } else {
    // simulate 2 rAF calls
    setTimeout(sendPageView, 32);
  }
};

exports.onRouteUpdate = onRouteUpdate;